import React, {useState, useEffect, useRef} from "react";
import {
    CustomButton,
    ToastNotification,
    ProgressLoader,
    InputTextCustomer,
    Select
} from "components/shared";
import validator from 'validator'
import 'primeflex/primeflex.css';
import {UsersService} from "services/http";
import UsersInit from './init';
import './admin.css';
import {CalendarCustomer, Discard} from "../../shared";
import {Calendar} from "primereact/calendar";

export function User(props) {
    const [error, setError] = useState(UsersInit.getError())
    const [data, setData] = useState(props.user)
    const [render, setRender] = useState(true)
    const [loading, setLoading] = useState(false)
    const [reset, setReset] = useState(false)
    const [affiliations, setAffiliations] = useState()
    const childRef = useRef();

    useEffect(() => {

        setRender(data.typeAuth !== 1)
        setLoading(true);
        UsersService.getUserAffiliations().then(data => {
            setAffiliations(data?.result);
            setLoading(false);
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
            setLoading(false);
        });
    }, []);


    useEffect(() => {
        setData(props.user);
        setError(UsersInit.getError());
        setLoading(false);
    }, [reset]);

    const _validateEmail = (e) => {
        if (e.target.value.length != 0) {
            if (!validator.isEmail(e.target.value)) {
                setError(prevState => {
                    return {...prevState, [e.target.name]: 'Enter valid Email!'}
                });
            } else {
                setError(prevState => {
                    return {...prevState, [e.target.name]: ''}
                });
            }
        } else {
            setError(prevState => {
                return {...prevState, [e.target.name]: ''}
            });
        }
    }
    const _validatePhone = (e) => {
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (e.target.value.length != 0) {
            if (!pattern.test(e.target.value)) {
                setError(prevState => {
                    return {...prevState, [e.target.name]: 'Please enter only number.!'}
                });

            } else {
                if (e.target.value.length != 10) {
                    setError(prevState => {
                        return {...prevState, [e.target.name]: 'Please enter valid phone number.!'}
                    });
                } else {
                    setError(prevState => {
                        return {...prevState, [e.target.name]: ''}
                    });
                }
            }
        } else {
            setError(prevState => {
                return {...prevState, [e.target.name]: ''}
            });
        }
    }

    function _validateRequired(name) {
        if (data[name]?.length === 0) {
            setError(prevState => {
                return {...prevState, [name]: 'Please fill in this field.!'}
            });
            return false;
        } else {
            setError(prevState => {
                return {...prevState, [name]: ''}
            });
            return true;
        }
    }

    function _validateError() {
        if (error.phoneNumber1
            || error.phoneNumber2
            || error.email) {
            return false;
        } else {
            return true;
        }
    }


    function _handleChange(e) {
        setData(prevState => {
            return {...prevState, [e.target.name]: e.target.value}
        });
    }

    function _handleChangeMap(name, value) {
        //console.log("change object item ->"+name+" ->"+value)
        setData(prevState => {
            return {...prevState, [name]: value}
        });
    }

    function _reset(e) {
        setLoading(true);
        setReset(!reset)
    }

    function _submit(e) {
        e.preventDefault();
        const _valid = _validateError();
        if (_validateRequired('teams') &&
            _validateRequired('competences') &&
            _validateRequired('roles') &&
            _validateRequired('languages') &&
            _valid) {
            setLoading(true);
            UsersService.submitUserUpdate(data).then(data => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "success",
                    title: "Success response",
                    message: data.message,
                    durable: false
                });
                props.refresh();
            }, error => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "warn",
                    title: "Error response",
                    message: error, durable: false
                });
            });
        }
    }

    const itemTemplate = (option) => {
        return <span className={`customer-badge status-${option.description}`}>{option.description}</span>;
    }

    return (
        <div>
            {loading ? <ProgressLoader/> :
                <form onSubmit={_submit}>
                    <div className="p-grid p-justify-center p-align-center">
                        <div className="p-col-10 p-fluid">
                            <div className="p-grid ">
                                <div className="p-col-6">
                                    <Select
                                        id="typeAuth"
                                        label='Type Authentication'
                                        select='single'
                                        name='typeAuth'
                                        value={'' + data.typeAuth}
                                        options={[
                                            {"description": 'LDAP', "value": '1'},
                                            {"description": 'Base de données', "value": '0'}
                                        ]}
                                        icon="pi pi-th-large"
                                        onChange={_handleChange}
                                        readOnly={true}
                                        required={true}
                                        filter={false}
                                        text='number'
                                        optionLabel='description'
                                        // item='value'
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="username" name='username'
                                                       onChange={_handleChange}
                                                       type="text" label='Username'
                                                       required={true}
                                                       disabled={!render}
                                                       icon="pi pi-user-edit"
                                                       value={data.username}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="firstName" name='firstName'
                                                       onChange={_handleChange}
                                                       type="text" label='Firstname'
                                                       disabled={!render}
                                                       icon="pi pi-user"
                                                       value={data.firstName}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="lastName" name='lastName'
                                                       onChange={_handleChange}
                                                       type="text" label='Lastname'
                                                       disabled={!render}
                                                       icon="pi pi-user"
                                                       value={data.lastName}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="phoneNumber1" name='phoneNumber1'
                                                       onChange={_handleChange}
                                                       type="text" label='Phone Number1 '
                                                       icon="pi pi-phone"
                                                       disabled={!render}
                                                       onBlur={_validatePhone}
                                                       validate={error?.phoneNumber1}
                                                       value={data.phoneNumber1}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="phoneNumber2" name='phoneNumber2'
                                                       onChange={_handleChange}
                                                       type="text" label='Phone Number2 '
                                                       icon="pi pi-phone"
                                                       onBlur={_validatePhone}
                                                       disabled={!render}
                                                       validate={error?.phoneNumber2}
                                                       value={data.phoneNumber2}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="email" name='email'
                                                       onChange={_handleChange}
                                                       type="text" label='Email'
                                                       icon="pi pi-envelope"
                                                       disabled={!render}
                                                       onBlur={_validateEmail}
                                                       validate={error?.email}
                                                       value={data.email}/>
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="teams"
                                        label='Teams'
                                        select='multiple'
                                        name='teams'
                                        icon="pi pi-slack"
                                        required={true}
                                        value={data?.teams}
                                        options={affiliations?.teams}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='teamId'
                                        onChange={_handleChangeMap}
                                        validate={error?.teams}
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="competences"
                                        label='Competences'
                                        select='multiple'
                                        name='competences'
                                        icon="pi pi-ticket"
                                        required={true}
                                        value={data.competences}
                                        options={affiliations?.competences}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='competenceId'
                                        onChange={_handleChangeMap}
                                        validate={error?.competences}
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="roles"
                                        label='Roles'
                                        select='multiple'
                                        name='roles'
                                        icon="pi pi-wallet"
                                        required={true}
                                        value={data.roles}
                                        options={affiliations?.roles}
                                        optionLabel='roleDescription'
                                        item='roleId'
                                        filterBy='roleDescription'
                                        onChange={_handleChangeMap}
                                        validate={error?.roles}
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="capacityNormal" name='capacityNormal'
                                                       onChange={_handleChange}
                                                       type="Number" label='Capacity normal'
                                                       icon="pi pi-user-minus"
                                                       required={true}
                                                       min={0}
                                                       value={data.capacityNormal}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="capacityMax" name='capacityMax'
                                                       onChange={_handleChange}
                                                       type="Number" label='Capacity max'
                                                       icon="pi pi-user-plus"
                                                       required={true}
                                                       min={0}
                                                       value={data.capacityMax}/>
                                </div>
                                {render&& <div className=" p-col-6">
                                    <CalendarCustomer id="expiryDate"
                                                      name='expiryDate'
                                                      onChange={_handleChange}
                                                      type="Date"
                                                      min={new Date()}
                                                      label='Expiry date'
                                                      icon="pi pi-calendar"
                                                      required={render}
                                                      value={data.expiryDate}/>
                                </div>}

                                <div className=" p-col-6">
                                    <Select
                                        id="languages"
                                        label='Languages'
                                        select='multiple'
                                        name='languages'
                                        icon="pi pi-slack"
                                        required={true}
                                        value={data?.languages}
                                        options={affiliations?.languages}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='languageId'
                                        onChange={_handleChangeMap}
                                        validate={error?.languages}
                                    />
                                </div>
                                <div className=" p-col-6">
                                </div>
                                <div className=" p-col-12"/>
                                <div className=" p-col-12"/>
                                <div className=" p-col-6"/>
                                <div className=" p-col-3">
                                    <Discard onClick={_reset}/>
                                </div>
                                <div className=" p-col-3">
                                    <CustomButton
                                        label="Submit"
                                        icon="bi bi-check-circle-fill"
                                        type='Submit'
                                        className="p-button-danger btc"
                                    />
                                </div>
                            </div>
                            {/*<div className="p-grid">*/}
                            {/*    <div className=" p-col-4">*/}
                            {/*        <ListBoxCustomer*/}
                            {/*            header='Roles'*/}
                            {/*            options={data.roles}*/}
                            {/*            disabled={props.readOnly}*/}
                            {/*            optionLabel="roleDescription"*/}
                            {/*            optionValue="roleDescription"*/}
                            {/*            onChange={(e) => {*/}
                            {/*            }}>*/}
                            {/*        </ListBoxCustomer>*/}
                            {/*    </div>*/}
                            {/*    <div className=" p-col-4">*/}
                            {/*        <ListBoxCustomer*/}
                            {/*            header='Competences'*/}
                            {/*            options={data.competences}*/}
                            {/*            disabled={props.readOnly}*/}
                            {/*            optionLabel="description"*/}
                            {/*            optionValue="description"*/}
                            {/*            onChange={(e) => {*/}
                            {/*            }}>*/}
                            {/*        </ListBoxCustomer>*/}
                            {/*    </div>*/}
                            {/*    <div className=" p-col-4">*/}
                            {/*        <ListBoxCustomer*/}
                            {/*            header='Teams'*/}
                            {/*            options={data.teams}*/}
                            {/*            disabled={props.readOnly}*/}
                            {/*            optionLabel="description"*/}
                            {/*            optionValue="description"*/}
                            {/*            onChange={(e) => {*/}
                            {/*            }}>*/}
                            {/*        </ListBoxCustomer>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                </form>
            }

            <ToastNotification ref={childRef}/>
        </div>
    );
}
